import styled from "styled-components";
import SVG from "react-inlinesvg";
// import { SelectDropdown } from "../../../../Assets/icons";

export const CalendarContainer = styled.div`
    background: ${props => (props.$container === 'popup' ? '#F6F6F6' : '#FFF')};
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px;
    width: ${props => (props.$container === 'popup' ? '100%' : '328px')};
    display: flex;
    flex-direction: column;
    gap: 5px;

    h2 {
        color: #333;
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 16px;
    }

    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF;
        border-radius: 10px;
    }

    .content-selected-month{
        display: grid;
        flex-direction: column;
        background-color: #FFFFFF;
        padding: 18px;
        gap:15px;
        border-radius: 10px;
    }

    .calendar-grid{
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(4, 1fr);
        max-width: 100%;
        text-align: center;
    }

    .header-row {
        background: #CBEDE2; 
        border-radius: 5px;
        display: grid;
        gap: 8px;
        grid-column: span 7; 
        grid-template-columns: repeat(7, 1fr);
        padding: 4px 0;
    }

    .empty-slot {
        visibility: hidden;
    }

    .month-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        color: #006560;
        cursor: default;
        width: 58px;
        height: 58px;

        &:hover{
            background-color: #3E78AA;
            border-color: #3E78AA;
            color: white;
            border-radius: 3px;
            font-weight: 400;
        }
    }

    .selected-month {
        background-color: #006560;
        border-radius: 3px;
        color: white;
        font-weight: 600;
    }

    .arrow{
        all: unset;
        cursor: pointer;
        padding: 8px 12px; 
    }
    
    button{
        bottom: 18px;
        font-size: 18px;
        font-weight: 600;
        padding: 8px 12px;
        margin-left: auto;
        text-transform: uppercase;
    }

`;

export const ButtonContainer = styled.div`
    padding-top: 8px;
    margin-left: auto;

`

export const BackIcon = styled(SVG)`   
    height: 20px;
    width: 20px;
`;